/* eslint-disable @typescript-eslint/no-explicit-any */
import Router from "next/router";
import { AppProps } from "next/app";
import { ApolloProvider } from "@apollo/client";

import NProgress from "nprogress";
import "nprogress/nprogress.css";

import { useApollo } from "@lib/apolloClientConfig";

import { initGA, logPageView } from "../lib/analytics";
import "@styles/app.scss";

import { useEffect } from "react";
import Analytics from "@components/Analytics";

import "@pravaler/amigoedu-ui/dist/index.css";

Router.events.on("routeChangeStart", () => NProgress.start());
Router.events.on("routeChangeComplete", () => NProgress.done());
Router.events.on("routeChangeError", () => NProgress.done());

function MyApp({ Component, pageProps }: AppProps): JSX.Element {
	const apolloClient = useApollo((pageProps as unknown as any).initialApolloState);

	useEffect(() => {
		if (!(window as any).GA_INITIALIZED) {
			initGA();
			(window as any).GA_INITIALIZED = true;
		}
		logPageView();
	}, []);

	return (
		<ApolloProvider client={apolloClient}>
			<Analytics />
			<Component {...pageProps} />
		</ApolloProvider>
	);
}

export default MyApp;
